import { z } from 'zod'

export const billingCatalogReadResponseSchema = z.object({}).passthrough()
export type BillingCatalogReadResponse = z.infer<typeof billingCatalogReadResponseSchema>
